import React from "react";

interface TotalDisplayProps {
  numberOfData: number;
}

export const TotalDisplay = ({ numberOfData }: TotalDisplayProps) => (
  <div className='px-4'>
    共&nbsp;
    <span className="font-bold text-lg text-ptTeal">
      {numberOfData.toLocaleString()}
    </span>
    &nbsp;筆資料
  </div>
)
